import clsx from 'clsx'
import { useRouter } from 'next/router'
import type { FC } from 'react'

import { NavItem, type NavItemProps } from '../NavItem'

type Menu = (NavItemProps & { key: string })[]

type NavbarProps = {
  className?: string
  menu: Menu
}

export const Navbar: FC<NavbarProps> = ({ className, menu }) => {
  const router = useRouter()

  const checkActive = (path?: string) => {
    if (!path) return false
    return router.asPath.includes(path)
  }

  return (
    <nav className={clsx('flex items-center gap-8', className)}>
      {menu.map(({ key, isDivider, path, label }) => {
        return (
          <NavItem
            key={key}
            isDivider={isDivider}
            path={path}
            label={label}
            active={checkActive(path)}
          />
        )
      })}
    </nav>
  )
}
